import React from 'react'

import {connect} from 'react-redux'

import OfflinePayment from '../../modules/offlinePayment/pages/OfflinePayment'
import Payment from '../../modules/payment/pages/Payment'
import LoadingScreen from '../../shared/components/LoadingScreen'
import Feedback from '../Feedback'
import OfflineFeedback from '../../modules/offlinePayment/pages/OfflineFeedback'
import NotSuccessfulPayment from '../NotSuccessfulPayment'
import * as qs from 'query-string';

/**
 * This is the root container of the app.
 */
class Base extends React.Component {
    render() {
        const {screen, resultData} = this.props
        const queryString = qs.parse(window.location.search)

        return (
            <div>
                {(screen === "" || screen === "offline-feedback") && !resultData.success && <NotSuccessfulPayment/>}
                {screen === "offline-payment" && <OfflinePayment queryString={queryString}/>}
                {screen === "payment" && <Payment queryString={queryString}/>}
                {screen === "loading" && <LoadingScreen/>}
                {screen === "feedback" && <Feedback/>}
                {screen === "offline-feedback" && resultData.success && <OfflineFeedback/>}
                {/*<Main/>*/}
            </div>
        )

    }
}

function mapStateToProps(state) {
    return {screen: state.forms.screen, resultData: state.forms.resultData}
}

const DataBound = connect(mapStateToProps)(Base)

export default DataBound
